export enum ContentProviderFeature {
	ATTRIBUTE_SOURCES_COUNT = 3,
	WIDGET_PREPROCESSING = 5,
}
